export default (data) => {
  const { userPreferences, updateVersion } = data || {};

  const {
    showIcons: { personalLinks: showIconsPersonalLinks },
  } = userPreferences;
  const showTexts = {
    personalLinks: false,
  };
  const showLinks = {
    personalLinks: !showIconsPersonalLinks,
  };

  return {
    ...userPreferences,
    showTexts,
    showLinks,
    version: {
      number: updateVersion,
      updated: true,
    },
  };
};
